module.exports = __webpack_public_path__ + "static/media/ZonaPro-Bold.aac55996.woff";